export default {
  search_placeholder: "Search FAQs...",
  no_results_title: "No results found",
  no_results_subtitle: "Try adjusting your search keywords or browse the categories on the left.",
  search_cleared_message: "Search cleared to show full content",
  still_have_questions: {
    before_email: "Still have questions? Contact us at ",
    after_email: " — our team will respond within 24 hours.",
  },
};
